import {
  Card,
  Image,
  Group,
  Text,
  Stack,
  HoverCard,
  Tooltip,
  // ActionIcon,
} from "@mantine/core";
import { motion } from "framer-motion";

interface ProjectProps {
  description: string;
  title: string;
  picture: string;
  builticon1: JSX.Element;
  builticon2?: JSX.Element;
  builticon3?: JSX.Element;
  builticon4?: JSX.Element;
  builticon5?: JSX.Element;
  icon1name: string;
  icon2name?: string;
  icon3name?: string;
  icon4name?: string;
  icon5name?: string;
  showcase1: JSX.Element;
  showcase2?: JSX.Element;
}

function Project(props: ProjectProps) {
  return (
    <HoverCard closeDelay={1000} radius="lg" position="bottom">
      <HoverCard.Target>
        <Card shadow="sm" p="lg" radius="lg" withBorder>
          <Card.Section>
            <Image src={props.picture} height={250} alt="Norway" />
          </Card.Section>

          {/* <Group position="apart" mt="md" mb="xs">
        <Text weight={500}>Bukit Better Driving Centre Website</Text>
        
        <Badge color="pink" variant="light">
                        On Sale
                      </Badge>
      </Group> */}

          <Stack mt="md" mb="xs">
            <Group>
              <Tooltip label={props.icon1name}>{props.builticon1}</Tooltip>
              {
                props.builticon2 && (
                  <Tooltip label={props.icon2name}>{props.builticon2}</Tooltip>
                )
              }
              {
                props.builticon3 && (
                  <Tooltip label={props.icon3name}>{props.builticon3}</Tooltip>
                )
              }
             {
                props.builticon4 && (
                  <Tooltip label={props.icon4name}>{props.builticon4}</Tooltip>
                )
              }
              {
                props.builticon5 && (
                  <Tooltip label={props.icon5name}>{props.builticon5}</Tooltip>
                )
              }
              
              {/* <Tooltip label={props.icon3name}>{props.builticon3}</Tooltip>
              <Tooltip label={props.icon4name}>{props.builticon4}</Tooltip>
              <Tooltip label={props.icon5name}>{props.builticon5}</Tooltip> */}
              
            </Group>
            <Text weight={500}>{props.title}</Text>
          </Stack>

          <Text size="sm" color="dimmed">
            {props.description}
          </Text>
        </Card>
      </HoverCard.Target>

      <HoverCard.Dropdown>
        <Group align="apart">
          <motion.div
            whileHover={{scale: 1.05}}
            whileTap={{scale: 0.9}}
            transition={{type:"spring", stiffness:400, damping: 17}}
          >
          {props.showcase1}
          </motion.div>
          
          <motion.div
          whileHover={{scale: 1.05}}
          whileTap={{scale: 0.9}}
          transition={{type:"spring", stiffness:400, damping: 17}}
          >
          {props.showcase2}
          </motion.div>
        </Group>
      </HoverCard.Dropdown>
    </HoverCard>
  );
}

export default Project;
